import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const createProject = api(async function createProject({ name, internalDescription, scheduleIds }) {
    return mutate(
        gql`
            mutation CreateProject($name: String!, $internalDescription: String, $scheduleIds: [String]) {
                createProject(name: $name, internalDescription: $internalDescription, scheduleIds: $scheduleIds) {
                    id
                    _id
                    _modified
                    _created
                    name
                    internalDescription
                    scheduleIds
                    phase
                }
            }
        `,
        { name, internalDescription, scheduleIds },
        { returns: "createProject" }
    )
})
